import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Form, Icon, Row, Col } from 'antd';
import BasePage from 'components/BasePage';
import styledComp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';
import FormDatePicker from 'components-desktop/FormDatePicker';
import FormInput from 'components-desktop/FormInput';
import FormSelect from 'components-desktop/FormSelect';
import Panel from 'components-desktop/Panel';
import helpers from 'misc/helpers';
import TablePayments from './components/TablePayments';

const propTypes = {
  form: PropTypes.object.isRequired,
};

@autobind
class SearchPaymentsPage extends BasePage {
  constructor(props) {
    super(props);

    this.state = {
      companies: [],

      tableKey: null,
      payments: null,
      isSearchButtonEnable: true,
    };
  }

  componentDidMount() {
    this.getSearchCriteria();
  }

  getTitle() {
    return 'Search Payments';
  }

  async getSearchCriteria() {
    const promise1 = this.callServiceForObjects('/company/get_id_names');

    const results = await Promise.all([promise1]);

    this.setState({
      companies: results[0],
    });
  }

  async searchPayments(values) {
    try {
      this.setState({
        isSearchButtonEnable: false,
      });

      const params = {
        companyId: helpers.extraFormSelectValue(values, 'companyId'),
        checkNumber: helpers.extraFormInputValue(values, 'checkNumber'),
        paymentMethod: helpers.extraFormSelectValue(values, 'paymentMethod'),
        receivedDate: helpers.extraFormDateValue(values, 'receivedDate'),
        checkDateFrom: helpers.extraFormDateValue(values, 'checkDateFrom'),
        checkDateTo: helpers.extraFormDateValue(values, 'checkDateTo'),
      };

      const payments = await this.callServiceForRemoteObjects('/payment/get_list', params);

      this.setState({
        tableKey: `${Date.now()}_${Math.random()}`,
        payments,
      });
    } finally {
      this.setState({
        isSearchButtonEnable: true,
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.searchPayments(values);
      }
    });
  }

  renderContent() {
    const { form } = this.props;
    const {
      companies,
      tableKey,
      payments,
      isSearchButtonEnable,
    } = this.state;

    return (
      <FlexColContainer
        width="match_parent"
        height="wrap_content"
        alignItems="center"
      >
        <Panel
          width="match_parent"
          height="wrap_content"
          margin="0 0 24px 0"
          color="yellow_gold"
          title="Search Payments by Criteria"
          icon="money-collect"
        >
          <styledComp.AntdForm
            width="match_parent"
            height="wrap_content"
            onSubmit={this.handleSubmit}
          >
            {/* Content */}
            <FlexColContainer
              width="match_parent"
              height="wrap_content"
              padding="20px 20px"
            >
              <Row type="flex" gutter={24}>
                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="companyId"
                    label="Company"
                    placeholder="Select..."
                    options={companies}
                  />
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <FormInput
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="checkNumber"
                    label="Check Number"
                  />
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <FormSelect
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="paymentMethod"
                    label="Payment Method"
                    placeholder="Select..."
                    initialValue="Check"
                    allowClear={false}
                    options={['Check', 'Other']}
                  />
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="receivedDate"
                    label="Received Date"
                    placeholder="mm/dd/yyyy"
                  />
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="checkDateFrom"
                    label="Check Date From"
                    placeholder="mm/dd/yyyy"
                    extra="Search payments from this check date"
                  />
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} xl={{ span: 6 }}>
                  <FormDatePicker
                    width="match_parent"
                    height="wrap_content"
                    form={form}
                    name="checkDateTo"
                    label="Check Date To"
                    placeholder="mm/dd/yyyy"
                    extra="Search payments to this check date"
                  />
                </Col>
              </Row>
            </FlexColContainer>

            {/* Footer */}
            <FlexRowContainer
              width="match_parent"
              height="wrap_content"
              padding="20px 20px"
              justifyContent="center"
              backgroundColor="containerGrayBackground"
            >
              <CustomButton
                width="wrap_content"
                height="32px"
                backgroundColor="yellow_gold"
                fontSize="14px"
                type="primary"
                loading={!isSearchButtonEnable}
                htmlType="submit"
              >
                SEARCH
                <Icon type="search" />
              </CustomButton>
            </FlexRowContainer>
          </styledComp.AntdForm>
        </Panel>

        {payments &&
          <TablePayments
            key={tableKey}
            width="match_parent"
            height="wrap_content"
            margin="0 0 24px 0"
            title="Payments"
            payments={payments}
          />
        }
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
SearchPaymentsPage.propTypes = propTypes;

export default Form.create()(SearchPaymentsPage);
